const ENDPOINTS = {

	GET_HABITACIONES: () =>
		'/api/v1/habitaciones/establecimiento/',


	GET_HABITACIONES_BY_PARAMS: (establecimientoId, activo, estado, edificio, planta, usuario, asignadas, noAsignadas, terminada, combinarCamas) => {

		let url = '/api/v1/habitaciones/establecimiento/' + establecimientoId +
			'?activo=' + activo +
			'&edificio=' + edificio +
			'&planta=' + planta;

		if (estado != '' && estado != null) {
			url += '&estado=' + estado
		}
		if (usuario != '' && usuario != null) {
			url += '&usuario=' + usuario
		}
		if (asignadas != null) {
			url += '&asignadas=' + asignadas
		}
		if (noAsignadas != null) {
			url += '&noAsignadas=' + noAsignadas
		}
		
		if(terminada!=null){
			url += '&terminada=' + terminada
		}
		
		if(combinarCamas!=null){
			url += '&combinarCamas=' + combinarCamas
		}

		return url;
	},
	
	GET_HABITACIONES_ASIGNABLES: (establecimientoId, estado, edificio, planta, usuario) => {

		let url = '/api/v1/habitaciones/establecimiento/' + establecimientoId +'/asignables/' + usuario +
			'?activo=1';
			

		if (edificio != '' && edificio != null) {
			url += '&edificio=' + edificio
		}
		if (estado != '' && estado != null) {
			url += '&estado=' + estado
		}
		if (planta != '' && planta != null) {
			url += '&planta=' + planta
		}
		

		return url;
	},

	GET_ESTADOS_HABITACION: () =>
		'/api/v1/habitaciones/estadosHabitacion/',

	POST_HABITACION: () =>
		'/api/v1/habitaciones/',

	DELETE_HABITACION: () =>
		'/api/v1/habitaciones/',

	ACTUALIZAR_HABITACION: (id) =>
		'/api/v1/habitaciones/' + id,

	CARGAR_FICHERO_HABITACIONES: (establecimientoId, borrar) => {
		return '/api/v1/habitaciones/' + establecimientoId +'/cargarFichero?borrarCargadas=' + borrar;
	},
	MARCAR_NO_TERMINADA: (id) => {
		return '/api/v1/habitaciones/' + id +'/noterminar/';
	},
	VALIDAR_HABITACION: (id, idUsuario) => {
		return '/api/v1/habitaciones/' + id +'/validar/' + idUsuario;
	}

};

export default ENDPOINTS;


